import React, { useState } from "react";
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router";
import { sendOTP, validateOTP, resetValidation } from "../../../redux/actions/auth";
import "./style.css";
import { isMobileDevice } from "../../../helper";

const OtpForm = ({ toggleForm }) => {

   const isMobile = isMobileDevice();
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const validation = useSelector(state => state.auth.validation);
   const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
   const mobile = useSelector(state => state.auth.mobile);

   const [OTP, setOTP] = useState("");
   const [error, setError] = useState(false);

   const handleSubmit = e => {
      e.preventDefault();
      if (mobile) {
         dispatch(validateOTP({ mobile, secret: OTP }, setOTP()));
      } else {
         setError(true);
      }
   };

   const resendOtp = e => {
      e.preventDefault();
      setError(false);
      dispatch(resetValidation());
      setOTP();
      dispatch(sendOTP({ mobile }));
   }

   const getTitle = () => {
      if (validation.hasOwnProperty("code") && validation?.code == 500) {
         return { title: validation.message, subtitile: "OTP is incorrect. Enter the correct OTP or click resend." }
      } else {
         return { title: "Existing users : Login", subtitile: "" }
      }
   }

   if (isAuthenticated) {
      navigate("dashboard");
   }

   return (
      <div className="otp-form form-sec">
         <p className="form-heading">{getTitle().title}</p>
         <form className="main-form">
            <p>{getTitle().subtitile}</p>
            <div className={`form-feild ${error ? 'form-error' : ''}`}>
               <label htmlFor="mobileno" className="form-label">
                  OTP
               </label>
               <OtpInput
                  value={OTP}
                  onChange={setOTP}
                  numInputs={6}
                  containerStyle="otp-outer"
                  shouldAutoFocus={true}
                  renderInput={(props) => <input type={isMobile ? 'number' : 'text'} inputMode='decimal' class="form-control mr-1 w-100" {...props} />}
               />
            </div>
            <button className="btn purple-button" onClick={(e) => handleSubmit(e)}>Submit</button>
            <button className="btn purple-outline-button" onClick={resendOtp}>Resend OTP</button>
            <div className="form-devider"></div>
            <p className="create-account">New User? <a className="nav-link" onClick={() => toggleForm(true)}>Create account</a></p>
         </form>
      </div>
   );
};

export default OtpForm;
